export enum BmReportsHistoryMessages {
  DELETE_LABEL = 'Delete',
  ARCHIVE_LABEL = 'Archive',
}
